import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from 'atoms/tooltip';


export default function HundredRating({ baseClassName, combinedRating, tooltipx, tooltipy, minRating, isBlock, adjective, numberComments, truncateText, adjectiveShown, t }) {
  return (
    <div className={ `hundred-rating ${baseClassName} ${isBlock ? '' : '-is-line'}` } style={ { display: combinedRating > minRating ? 'block' : 'none' } }>
      <Tooltip
        baseClassName="hundred-rating__tooltip-container"
        position="bottom"
        space={ 0 }
        title={ t("Hundred Rating evaluates real guest experiences and the scores on different websites") }
        tooltipX={ tooltipx }
        tooltipY={ tooltipy }
      >
        <div className="hundred-rating__tooltip-container__inner">
          <div className="hundred-rating__tooltip-container__inner__rating">
            { combinedRating < 10 ? combinedRating.toFixed(1) : 10 }
          </div>
          { isBlock
            ? <div className="hundred-rating__tooltip-container__inner__line-block" />
            : (
              <span className="hundred-rating__tooltip-container__inner__dot">
                { " · " }
              </span>
            )
          }
          <div className="hundred-rating__tooltip-container__inner__sub-block">
            { adjective
              ? (
                <div className={ `hundred-rating__tooltip-container__inner__sub-block__adjective ${adjectiveShown || numberComments === 0 ? '' : '-no-adjective-responsive'}` }>
                  { t(adjective) }
                </div>
              )
              : (
                <div className={ `hundred-rating__tooltip-container__inner__sub-block__adjective ${adjectiveShown && numberComments === 0 ? '' : '-no-adjective-responsive'}` }>
                  { t('Rating') }
                </div>
              )
            }
            { !isBlock && numberComments
              ? <div className={ `hundred-rating__tooltip-container__inner__line-noblock ${adjectiveShown ? '' : '-no-adjective-responsive'}` } />
              : null
            }
            { numberComments
              ? (
                <div className="hundred-rating__tooltip-container__inner__sub-block__comments">
                  { `${numberComments} ${truncateText ? t('com.') : numberComments > 1 ? t('comments') : t('comment')}` }
                </div>
              )
              : null
            }
          </div>
        </div>
      </Tooltip>
    </div>
  );
}

HundredRating.defaultProps = {
  adjective: '',
  adjectiveShown: true,
  baseClassName: '',
  isBlock: true,
  minRating: 5,
  numberComments: 0,
  tooltipx: 100,
  tooltipy: 100,
  truncateText: true,
};

HundredRating.propTypes = {
  adjective: PropTypes.string,
  adjectiveShown: PropTypes.bool,
  baseClassName: PropTypes.string,
  combinedRating: PropTypes.number.isRequired,
  isBlock: PropTypes.bool,
  minRating: PropTypes.number,
  numberComments: PropTypes.number,
  t: PropTypes.func.isRequired,
  tooltipx: PropTypes.number,
  tooltipy: PropTypes.number,
  truncateText: PropTypes.bool,
};
